import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import { format } from "date-fns";
import { config, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const OpportunityDetail = () => {
  const { id_opportunity } = useParams();
  const [opportunity, setOpportunity] = useState(null);
  const [lead, setLead] = useState(null);
  const [quotations, setQuotations] = useState(null);
  const [isComplete, setIsComplete] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const navigate = useNavigate();

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    getOpportunity();
  }, []);

  useEffect(() => {
    if (opportunity) {
      if (opportunity.lead_id) {
        getLead();
      }
      getQuotations();
      if (
        opportunity.opportunity_enquiry &&
        opportunity.opportunity_source &&
        opportunity.opportunity_deal_type &&
        opportunity.opportunity_product_line &&
        opportunity.opportunity_product_detail &&
        opportunity.opportunity_product_months &&
        opportunity.opportunity_expected_closed &&
        opportunity.opportunity_expected_revenue &&
        opportunity.opportunity_expected_profit
      ) {
        setIsComplete(true);
      }
    }
  }, [opportunity]);

  const getOpportunity = async () => {
    try {
      const requestGetOpportunity = {
        "id_opportunity": id_opportunity
      }
      const fetchGetOpportunity = await jwtFetch(config.ENDPOINT + 'get/opportunity', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetOpportunity)
      });
      const responseGetOpportunity = await fetchGetOpportunity.json();
      if (responseGetOpportunity.status === 200) {
        if (responseGetOpportunity.data[0].website_form) {
          const websiteForm = JSON.parse(responseGetOpportunity.data[0].website_form);
          responseGetOpportunity.data[0].website_form = websiteForm;
        }
        setOpportunity(responseGetOpportunity.data[0]);
      } else {
        alert(responseGetOpportunity.message);
      }
    } catch (error) {
      console.error('Error in getOpportunity:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getLead = async () => {
    try {
      const requestGetLead = {
        "id_lead": opportunity.lead_id
      }
      const fetchGetLead = await jwtFetch(config.ENDPOINT + 'get/lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetLead)
      });
      const responseGetLead = await fetchGetLead.json();
      if (responseGetLead.status === 200) {
        setLead(responseGetLead.data[0]);
      } else {
        alert(responseGetLead.message);
      }
    } catch (error) {
      console.error('Error in getLead:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getQuotations = async () => {
    try {
      const requestGetQuotations = {
        opportunity_id: opportunity.id_opportunity
      }
      const fetchGetQuotations = await jwtFetch(config.ENDPOINT + 'get/quotation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetQuotations)
      });
      const responseGetQuotations = await fetchGetQuotations.json();
      if (responseGetQuotations.status === 200) {
        setQuotations(responseGetQuotations.data);
      } else {
        alert(responseGetQuotations.message);
      }
    } catch (error) {
      console.error('Error in getQuotations:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const editStatus = async (status) => {
    try {
      setIsLoadingSubmit(true);
      const fetchEditOpportunity = await jwtFetch(config.ENDPOINT + 'update/opportunity', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_opportunity: opportunity.id_opportunity,
          opportunity_status: status
        })
      });
      const responseEditOpportunity = await fetchEditOpportunity.json();
      if (responseEditOpportunity.status === 200) {
        if (status === 'Opportunity') {
          navigate('/quotation/add/' + opportunity.company_id + '/' + opportunity.subcompany_id + '/' + opportunity.id_opportunity);
        }
        window.location.reload();
      }
    } catch (error) {
      console.error('Error in editStatus:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div id="opportunity-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="opportunity" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                {opportunity ? (
                  <section className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Opportunity Detail</div>
                        {(opportunity.opportunity_source === 'Personal' || opportunity.opportunity_source === 'Principal') ? (
                          <span className="badge badge-sm ms-3 text-bg-success">{opportunity.opportunity_source}</span>
                        ) : (
                          <span className="badge badge-sm ms-3 text-bg-info">Marketing</span>
                        )}
                        {opportunity.opportunity_status === 'Open' && (
                          <span className="badge badge-sm ms-1 text-bg-secondary">Open</span>
                        )}
                        {opportunity.opportunity_status === 'Opportunity' && (
                          <span className="badge badge-sm ms-1 text-dark text-bg-gold">Opportunity</span>
                        )}
                        {opportunity.opportunity_status === 'On Hold' && (
                          <span className="badge badge-sm ms-1 text-light text-bg-warning">On Hold</span>
                        )}
                        {opportunity.opportunity_status === 'Lost' && (
                          <span className="badge badge-sm ms-1 text-light text-bg-danger">Lost</span>
                        )}
                        {opportunity.opportunity_status === 'Won' && (
                          <span className="badge badge-sm ms-1 text-light text-bg-success">Won</span>
                        )}
                      </div>
                      {(opportunity.opportunity_status === 'Open' && crmUser.user_level !== 'View') && (
                        <div className="d-flex align-items-center justify-content-between gap-2">
                          <button className="btn btn-sm btn-outline-warning" onClick={() => editStatus('On Hold')} disabled={isLoadingSubmit}><i className="bi bi-hourglass me-2" /> On Hold</button>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => editStatus('Lost')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-2" /> Lost</button>
                          {/* <button className="btn btn-sm btn-success" onClick={() => editStatus('Opportunity')} disabled={isLoadingSubmit}><i className="bi bi-plus-lg me-1"/> Create Quotation</button> */}
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Number</div>
                          <div className="col-md-8">{opportunity.opportunity_code}</div>
                        </div>
                        {opportunity.company_name ? (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Company Group</div>
                            <div className="col-md-8">{opportunity.company_name} <a href={"/client/detail/" + opportunity.company_id}><i className="bi bi-link-45deg" /></a></div>
                          </div>
                        ) : (
                          opportunity.website_form && (
                            <div className="row mb-2">
                              <div className="col-md-4 text-secondary">Company</div>
                              <div className="col-md-8">{opportunity.website_form.company_name}</div>
                            </div>
                          )
                        )}
                        {opportunity.subcompany_name && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Subsidiary</div>
                            <div className="col-md-8">{opportunity.subcompany_name} <a href={"/client/subsidiary/detail/" + opportunity.subcompany_id}><i className="bi bi-link-45deg" /></a></div>
                          </div>
                        )}
                        {opportunity.contact_name && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Contact Person</div>
                            <div className="col-md-8">{opportunity.contact_name} <a href={"/client/contact/detail/" + opportunity.contact_id}><i className="bi bi-link-45deg" /></a></div>
                          </div>
                        )}
                        {opportunity.opportunity_status === 'Open' && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Open For</div>
                            <div className="col-md-8">
                              {(() => {
                                const createdDate = new Date(opportunity.created_on);
                                const today = new Date();
                                const timeDiff = today.getTime() - createdDate.getTime();
                                const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                                return Math.max(1, daysDiff);
                              })()} days
                            </div>
                          </div>
                        )}
                        {/* <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Deal Type</div>
                          <div className="col-md-8">{opportunity.opportunity_deal_type}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Product Line</div>
                          <div className="col-md-8">{opportunity.opportunity_product_line}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Product Detail</div>
                          <div className="col-md-8">{opportunity.opportunity_product_detail}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Months</div>
                          <div className="col-md-8">{opportunity.opportunity_product_months > 1 ? opportunity.opportunity_product_months + ' months' : opportunity.opportunity_product_months + ' month'}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Expected Closing Date</div>
                          <div className="col-md-8">{format(new Date(opportunity.opportunity_expected_closed), 'd MMM yyyy')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Estimated Revenue</div>
                          <div className="col-md-8">{priceFormat(opportunity.opportunity_expected_revenue, 'USD')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Estimated Profit</div>
                          <div className="col-md-8">{priceFormat(opportunity.opportunity_expected_profit, 'USD')}</div>
                        </div> */}
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Created Date</div>
                          <div className="col-md-8">{format(new Date(opportunity.created_on), 'd MMM yyyy')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Sales Person</div>
                          <div className="col-md-8">{opportunity.sales_name}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {lead && opportunity.lead_id && (
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fs-14 mb-0"><strong>Lead</strong></p>
                                <a href={"/lead/detail/" + lead.id_lead}>{lead.lead_code} <i className="bi bi-link-45deg ms-1" /></a>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </section>
                ) : (
                  <p>No data</p>
                )}

                {lead && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Enquiry & BANT</strong></p>
                          {crmUser.user_level !== 'View' && (
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => window.open('/opportunity/edit/bant/' + opportunity.id_opportunity)}><i className="bi bi-pencil me-1" /> Edit</button>
                          )}
                        </div>
                        <div className="p-2">
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Message</div>
                            <div className="col-md-10">{lead.lead_enquiry}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Budget</div>
                            <div className="col-md-10">{priceFormat(lead.bant_budget, 'IDR')}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Authority</div>
                            <div className="col-md-10">{lead.bant_authority}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Need</div>
                            <div className="col-md-10">{lead.bant_need}</div>
                          </div>
                          <div className="row">
                            <div className="col-md-2 text-secondary">Timeline</div>
                            <div className="col-md-10">{lead.bant_timeline}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {/* {opportunity && lead && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Remarks</strong></p>
                        </div>
                        <div className="p-2">
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Marketing</div>
                            <div className="col-md-10">{lead.source_remarks}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Sales</div>
                            <div className="col-md-10">{opportunity.opportunity_remarks}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )} */}

                {opportunity && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Details</strong></p>
                          {crmUser.user_level !== 'View' && (
                            <>
                              {
                                isComplete ? (
                                  <button className="btn btn-sm btn-outline-secondary" onClick={() => window.open('/opportunity/edit/detail/' + opportunity.id_opportunity)}><i className="bi bi-pencil me-1" /> Edit</button>
                                ) : (
                                  <button className="btn btn-sm btn-outline-secondary" onClick={() => window.open('/opportunity/edit/detail/' + opportunity.id_opportunity)}><i className="bi bi-pencil me-1" /> Complete Form</button>
                                )}
                            </>
                          )}
                        </div>
                        <div className="p-2">
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Enquiry</div>
                            <div className="col-md-10">{opportunity.opportunity_enquiry}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Source</div>
                            <div className="col-md-10">{opportunity.opportunity_source}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Deal Type</div>
                            <div className="col-md-10">{opportunity.opportunity_deal_type}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Product Line</div>
                            <div className="col-md-10">{opportunity.opportunity_product_line}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Product Detail</div>
                            <div className="col-md-10">{opportunity.opportunity_product_detail}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Months</div>
                            <div className="col-md-10">{opportunity.opportunity_product_months > 1 ? opportunity.opportunity_product_months + ' months' : opportunity.opportunity_product_months + ' month'}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Expected Closing Date</div>
                            <div className="col-md-10">{format(new Date(opportunity.opportunity_expected_closed), 'dd MMM yyyy')}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Estimated Revenue</div>
                            <div className="col-md-10">{priceFormat(opportunity.opportunity_expected_revenue, 'IDR')}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Estimated Profit</div>
                            <div className="col-md-10">{priceFormat(opportunity.opportunity_expected_profit, 'IDR')}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Remarks</div>
                            <div className="col-md-10">{opportunity.opportunity_remarks}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {opportunity && (
                  <section className="mb-4">
                    {/* <Tabs className="mb-3" defaultActiveKey="quotations">
                      <Tab eventKey="quotations" title="Quotations"> */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="fs-24">Quotation List</div>
                      {(isComplete && crmUser.user_level !== 'View') && (
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => window.open('/quotation/add/' + opportunity.company_id + '/' + opportunity.subcompany_id + '/' + opportunity.id_opportunity)}><i className="bi bi-plus-lg me-1" /> Add</button>
                      )}
                    </div>
                    {quotations && quotations.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-primary text-light">#</th>
                              <th className="bg-primary text-light">Number</th>
                              <th className="bg-primary text-light text-center">Status</th>
                              <th className="bg-primary text-light">Created Date</th>
                              <th className="bg-primary text-light">SKUs</th>
                              <th className="bg-primary text-light text-end">Amount</th>
                              <th className="bg-primary"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {quotations.map((quotation, q) =>
                              <tr key={"quotation-" + [q]} onClick={() => window.location.href = '/quotation/detail/' + quotation.id_quotation}>
                                <td valign="middle">{q + 1}</td>
                                <td valign="middle">{quotation.quotation_code}</td>
                                <td valign="middle" align="center"><span className={"badge bg-" + (quotation.quotation_status === 'Won' ? 'success' : 'secondary')}>{quotation.quotation_status}</span></td>
                                <td valign="middle">{format(quotation.created_on, 'd MMM yyyy')}</td>
                                <td valign="middle" title={quotation.item_list_names}>{quotation.item_list}</td>
                                <td valign="middle" align="right">{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</td>
                                <td valign="middle" align="right"><button type="button" className="btn btn-icon btn-outline-secondary" aria-label="View quotation"><i className="bi bi-eye" /></button></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>No data</p>
                    )}
                    {/* </Tab>
                    </Tabs> */}
                  </section>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default OpportunityDetail;


